import { CONFIG } from 'src/common/config'
import { configurationCookiesConfig, removeUssIdFromCookies, setUssidToCookies } from 'src/common/functions'
import { Cookies } from 'src/core/utils/cookies'

class TokenService {
  constructor() {
    this.cookieKey = process.env.TOKEN_KEY
  }
  setToken(token, ussid) {
    const configCookies = configurationCookiesConfig(token, CONFIG.COOKIES_OPTIONS)
    Cookies.set(this.cookieKey, token, configCookies)
    if (ussid) {
      return setUssidToCookies(ussid, configCookies.expires)
    }

    return undefined
  }
  getToken() {
    return Cookies.get(this.cookieKey)
  }
  removeToken() {
    Cookies.remove('ussid', CONFIG.COOKIES_OPTIONS_REMOVE)
    Cookies.remove('ssid', CONFIG.COOKIES_OPTIONS_REMOVE)
    Cookies.remove(this.cookieKey, CONFIG.COOKIES_OPTIONS_REMOVE)

    return removeUssIdFromCookies()
  }
}

export const tokenService = new TokenService()
